module.exports = __webpack_public_path__ + "static/img/观光车.8e40b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/观光车.jpg
// module id = H0up
// module chunks = 1